import { Card, Typography } from 'antd';
import './styles.css';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@seaters-app/ui';
import { Link, useSearchParams } from 'react-router-dom';
import { SEATERS_APP_BASE_URL, routes } from '@seaters-app/constants';
import { getSlugFromUrl } from '@seaters-app/data-access';

const { Title, Text } = Typography;

function EmailConfirmation() {
  const slug = getSlugFromUrl();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') ?? '';
  // TODO: we need to handle this better, in some email clients the request to the backend already happens, then we enter this flow a second time and we run into the error.
  // So for now we just hide the error, act like it always succeeds.
  const hasError = false; // searchParams.get('error') !== null;
  const redirectURI = decodeURIComponent(redirect)
    ? decodeURIComponent(redirect)
    : `${SEATERS_APP_BASE_URL}${slug}/${routes.landing}`;

  return (
    <Card className="publicForm" bordered={false}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {hasError ? (
          <CloseCircleOutlined
            style={{ fontSize: '30px', marginBottom: '24px', color: '#ff4d4f' }}
            rev={undefined}
          />
        ) : (
          <CheckCircleOutlined
            style={{ fontSize: '30px', marginBottom: '24px' }}
            rev={undefined}
          />
        )}
        <Title level={5}>
          {hasError
            ? t('email_confirmation_error_title', 'Email Confirmation Failed')
            : t('email_confirmation_general_title')}
        </Title>
        <Text>
          {hasError
            ? t(
                'email_confirmation_error_message',
                'The confirmation link has expired or has already been used. Please try requesting a new confirmation email.'
              )
            : t('email_confirmation_general_message')}
        </Text>
        <Link to={redirectURI}>
          <Button style={{ marginTop: 16 }} type="primary">
            {t('go_to_fg_button_text')}
          </Button>
        </Link>
      </div>
    </Card>
  );
}

export default EmailConfirmation;
